import React from "react";
import RNButton from "@components/Button";

const Button = ({
  formItem,
  onSubmit,
  buttonWidth = "100%",
  buttonStyles = {},
  // borderRadius = 0,
}) => {
  return formItem.type !== "submit" ? (
    <RNButton
      buttonWidth={buttonWidth}
      btnText={formItem && formItem.label}
      onPress={onSubmit}
      {...{ buttonStyles }}
    />
  ) : (
    <RNButton
      buttonWidth={30}
      btnText={formItem && formItem.label}
      buttonFontType="head2"
      height={56}
      onPress={onSubmit}
      // {...{ buttonStyles }}
      containerStyle={{
        alignSelf: "center",
        marginTop: 20,
        width: 30,
      }}
      borderRadius={6}
    />
  );
};

export default Button;
